<script>
  import { createEventDispatcher } from "svelte";

  const dispatch = createEventDispatcher();
  export let feedbackType = "";
  export let stravaLink = "";
  export let feedback = "";
  export let showModal = false;
  export let id_assessoria = 0;
  export let treino = {};
  export let data_feito = "";
  function handleSave() {
    dispatch("saveFeedback", {
      feedbackType,
      stravaLink,
      feedback,
      data_feito,
    });
    showModal = false; // Fechar o modal após salvar o feedback
  }
  function ApagarTreino() {
    dispatch("apaga", { feedbackType, stravaLink, feedback, data_feito });
    showModal = false; // Fechar o modal após salvar o feedback
  }

  function closeModal() {
    showModal = false;
  }
</script>

{#if showModal}
  <div
    class="modal d-block"
    tabindex="-1"
    aria-labelledby="feedbackModalLabel"
    aria-hidden="true"
    style="background-color: rgba(0, 0, 0, 0.5);"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5>Treino</h5>
          <button
            type="button"
            class="btn-close ms-auto"
            on:click={closeModal}
            aria-label="Close"
          ></button>
        </div>
        <div class="treino-section">
          <!-- Título adicionado -->
          <div class="treino-content">
            <div><strong>Treino:</strong> {@html treino.Treino}</div>
            <hr />
            <div>
              <strong>Intervalos:<br /></strong>
              {@html treino.Intervalos}
            </div>
            <hr />
            <div>
              <strong>Observações:<br /></strong>
              {@html treino.observacao}
            </div>
          </div>
        </div>

        <div class="modal-body">
          <h5 class="modal-title" id="feedbackModalLabel">
            Feedback do Treino
          </h5>
          <p>Feito?</p>
          <div class="btn-group d-flex" role="group" aria-label="Feedback Type">
            <input
              type="radio"
              class="btn-check"
              id="naoFeito"
              autocomplete="off"
              bind:group={feedbackType}
              value="0"
            />
            <label class="btn btn-outline-secondary flex-fill" for="naoFeito"
              >Não</label
            >

            <input
              type="radio"
              class="btn-check"
              id="parcialmente"
              autocomplete="off"
              bind:group={feedbackType}
              value="1"
            />
            <label
              class="btn btn-outline-secondary flex-fill"
              for="parcialmente">Parcialmente</label
            >

            <input
              type="radio"
              class="btn-check"
              id="feito"
              autocomplete="off"
              bind:group={feedbackType}
              value="2"
            />
            <label class="btn btn-outline-secondary flex-fill" for="feito"
              >Realizado</label
            >
          </div>
          <div class="mb-3">
            <label for="stravaLink" class="form-label">Link do Strava</label>
            <input
              type="text"
              class="form-control"
              id="stravaLink"
              bind:value={stravaLink}
            />
          </div>
          <div class="mb-3">
            <label for="feedback" class="form-label">Feedback</label>
            <textarea
              class="form-control"
              id="feedback"
              rows="3"
              bind:value={feedback}
            ></textarea>
          </div>
          <div class="mb-3">
            <label for="data" class="form-label">Data</label>
            <input
              type="date"
              class="form-control"
              id="data"
              bind:value={data_feito}
            />
          </div>
        </div>

        <div class="modal-footer">
          {#if id_assessoria > 0}
            <button type="button" class="btn btn-danger" on:click={ApagarTreino}
              >Apagar este treino</button
            >
          {/if}
          <button type="button" class="btn btn-secondary" on:click={closeModal}
            >Fechar</button
          >
          <button type="button" class="btn btn-primary" on:click={handleSave}
            >Salvar Feedback</button
          >
        </div>
      </div>
    </div>
  </div>
{/if}

<style>
  .modal {
    display: block; /* Override display property */
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1050;
    width: 100%;
    height: 100%;
    overflow: hidden;
    outline: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.5);
  }
  .treino-section {
    margin-bottom: 1rem;
    min-width: 100%;
  }

  .treino-content {
    max-height: 200px; /* Altura máxima */
    overflow-y: auto; /* Barra de rolagem vertical */
    min-width: 100%;
    background-color: #f8f9fa; /* Fundo levemente cinza */
    padding: 10px;
    border-radius: 5px;
  }
  .modal-dialog {
    max-width: 500px;
    margin: auto;
    pointer-events: none;
  }

  .modal-content {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    pointer-events: auto;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 0.3rem;
    outline: 0;
    max-height: 100vh; /* Altura máxima do conteúdo */
    overflow-y: auto; /* Habilita rolagem no conteúdo */
  }

  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    justify-content: space-between;
    padding: 1rem 1rem;
    border-bottom: 1px solid #dee2e6;
    border-top-left-radius: 0.3rem;
    border-top-right-radius: 0.3rem;
  }

  .modal-title {
    margin: 0;
  }

  .btn-close {
    padding: 0.25rem 0.5rem;
    margin: -0.25rem -0.5rem -0.25rem auto;
  }

  .modal-body {
    position: relative;
    flex: 1 1 auto;
    padding: 1rem;
  }

  .modal-footer {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    padding: 0.75rem;
    border-top: 1px solid #dee2e6;
    border-bottom-right-radius: 0.3rem;
    border-bottom-left-radius: 0.3rem;
  }

  .btn-group .btn-check:checked + .btn {
    background-color: #0d6efd;
    color: white;
  }
</style>
